import api from './API';
import Cookie from 'universal-cookie';
import UtilityFunction from '../Util/Util';

const { responseFormat } = UtilityFunction;
const cookies = new Cookie();

const basePath = 'auth';
const pathList = {
    login: `/login`,
    register: `/register`,
    me: `/me`,
    logout: `/logout`,
    address: `/address/:param`,
    updateAccount: `/me/account`,

    generateOtp: `/generate-otp`,
    sendOtp: `/send-otp`,

    verifyEmail: `/verify-email`,
    updatePassword: `/update-password`,
    verifyResetPasswordToken: `/verify-reset-password`
};

for(let key in pathList) {
    pathList[key] = basePath + pathList[key];
}

const isAuthenticated = async (argToken) => {
    try {
        const apiPath = pathList.me;
        const response = await api.getCall(apiPath, null, {}, {
            "Authorization": argToken
        });

        return response;
    } catch(e) {
        console.log(e.toString());
    }
}

const login = async (email, password) => {
    try {
        const apiPath = pathList.login;
        const response = await api.postCall(apiPath, null, {
            email,
            password
        });

        return response;
    } catch(e) {
        console.log(e.toString());
    }
};

const register = async (fullname, email, phoneNo, password, confirmPassword) => {
    try {
        const apiPath = pathList.register;
        const response = await api.postCall(apiPath, null, {
            fullname,
            phoneNo,
            email,
            password,
            confirmPassword
        });

        return response;
    } catch(e) {
        console.log(e.toString());
    }
}

const logout = async (argToken) => {
    try {
        const apiPath = pathList.logout;
        const response = await api.getCall(apiPath, null, {}, {
            "Authorization": argToken
        });
    
        return response;
    } catch(e) {
        console.log(e.toString());
    }
}

const addressSave = async (addressId, addressData) => {
    try {
        const apiPath = pathList.address;
        let response;
        let authToken = cookies.get('authToken');
    
        if(!authToken) return responseFormat(-1, 'Not Authenticated');
    
        if(addressId > 0) {
            response = await api.putCall(apiPath, addressId, addressData, {
                "Authorization": authToken
            });
        } else {
            response = await api.postCall(apiPath, "", addressData, {
                "Authorization": authToken
            });
        }

        return response;
    } catch(e) {
        console.log(e.toString());
    }
}

const addressDelete = async (addressId) => {
    try {
        const apiPath = pathList.address;
        let response;
        let authToken = cookies.get('authToken');
    
        if(!authToken) return responseFormat(-1, 'Not Authenticated');
    
        response = await api.deleteCall(apiPath, addressId, {}, {
            "Authorization": authToken
        });

        return response;
    } catch(e) {
        console.log(e.toString());
    }
}

const updateAccount = async (accountData) => {
    let authToken = cookies.get('authToken');
    if(!authToken) return responseFormat(-1, 'Not Authenticated');
    
    try {
        const apiPath = pathList.updateAccount;
        const response = api.putCall(apiPath, null, accountData, {
            'Authorization': authToken
        });
    
        return response;
    } catch(e) {
        console.log(e.toString());
    }
}

const otpGenerate = async (customerCode) => {
    try {
        const apiPath = pathList.generateOtp;
        let response;
    
        response = await api.postCall(apiPath, null, {customerCode});

        return response;
    } catch(e) {
        console.log(e.toString());
    }
};

const otpVerify = async (customerCode, otp) => {
    try {
        const apiPath = pathList.sendOtp;
        let response;
    
        response = await api.postCall(apiPath, null, {customerCode, otp});

        return response;
    } catch(e) {
        console.log(e.toString());
    }
}

// POST
const verifyEmail = async (email) => {
    try {
        const apiPath = pathList.verifyEmail;
        let response;
    
        response = await api.postCall(apiPath, null, { customer_email: email });

        return response;
    } catch(e) {
        console.log(e.toString());
    }
};

// POST
const verifyResetPasswordToken = async (token) => {
    try {
        const apiPath = pathList.verifyResetPasswordToken;
        let response;
    
        response = await api.postCall(apiPath, null, { token });

        return response;
    } catch(e) {
        console.log(e.toString());
    }
};

// POST
const resetPassword = async (token, password, confirmPassword) => {
    try {
        const apiPath = pathList.updatePassword;
        let response;
    
        response = await api.postCall(apiPath, null, { token, password, confirm_password: confirmPassword });

        return response;
    } catch(e) {
        console.log(e.toString());
    }
};

const authAPI = {
    isAuthenticated,
    login,
    register,
    logout,
    addressSave,
    addressDelete,
    updateAccount,

    otpGenerate,
    otpVerify,

    verifyEmail,
    verifyResetPasswordToken,
    resetPassword
}

export default authAPI;